import type { InputConfig } from "@smartsuite/automation-engine-api";
import { WHEN_BUTTON_IS_CLICKED_BUTTON_LABEL } from "./constants";
import { pickValueConfigString } from "./inputs";

// The copy's button slug and webhook id are settled anew by their
// integrations when it is created, as the original's are taken.
export const duplicateInput = (input: InputConfig): InputConfig => {
  if (input.inputId === WHEN_BUTTON_IS_CLICKED_BUTTON_LABEL) {
    if (input.value === undefined) {
      throw new Error("Button label value is undefined");
    }

    const buttonLabel = pickValueConfigString(input.value);

    if (buttonLabel === undefined) {
      throw new Error("Button label is undefined");
    }

    return {
      ...input,
      value: {
        values: [
          {
            value: {
              oneofKind: "string",
              string: `${buttonLabel} (copy)`,
            },
          },
        ],
      },
    };
  }

  return input;
};
